<section class="celebration">
	<img
		[src]="partyHornSrc"
		aria-hidden="true"
		class="celebration__party-popper"
	/>
	<h1 class="c-page-heading celebration__heading"> You've added a vet clinic for {{ petName$ | async }}!</h1>
	<p
		*ngIf="!(cannotFindVet$ | async)"
		class="celebration__copy"
	> Thank you! We will be reaching out to {{ clinicName$ | async }} to request medical history.</p>
	<p
		*ngIf="cannotFindVet$ | async"
		class="celebration__copy"
	> Thank you! We will be reaching out to {{ newVetClinicName$ | async }} to request medical history, and you'll see
		this vet added to your pet's details in 5 business days.</p>
	<section class="celebration__actions">
		<button
			class="c-cta celebration__actions-item m--add"
			data-quat="action_addAnotherVet"
			(click)="addAdditionalVet()"
		>Add Another Vet Clinic</button>
		<button
			class="c-cta m--ghost celebration__actions-item m--home"
			data-quat="action_goHome"
			(click)="close()"
		>Go Home</button>
	</section>
</section>